module.exports = __webpack_public_path__ + "static/img/logo-clac.c12a935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-clac.png
// module id = iUA7
// module chunks = 1